import script from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"
export * from "./fromThirdReg.vue?vue&type=script&setup=true&lang=js"

import "./fromThirdReg.vue?vue&type=style&index=0&id=a25d8d6c&lang=less&scoped=true"

import exportComponent from "/data/web/pay/agpay/antpay-h5-hengban/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a25d8d6c"]])

export default __exports__